import type { AxiosInstance } from 'axios';
import type { ServiceResult } from '../types/common/ServiceResult';
import type { ServiceResultT } from '../types/common/ServiceResultT';
import type { FavoriteListingCreateModel } from '../types/favorite-listing/FavoriteListingCreateModel';
import type { FavoriteListingViewModel } from '../types/favorite-listing/FavoriteListingViewModel';
import { apiClient } from '../client/client';

/**
 * Favorite listing service – add/remove via POST, list by user via GET.
 * POST api/favorite-listing with userId + listingId toggles (add if absent, remove if present).
 */
export class FavoriteListingService {
  private static readonly BASE = '/api/favorite-listing';

  constructor(private readonly client: AxiosInstance = apiClient) {}

  /**
   * Toggle favorite: add or remove the listing for the user.
   * Same request adds when not favorited and removes when favorited.
   */
  async toggle(payload: FavoriteListingCreateModel): Promise<ServiceResult> {
    const { data } = await this.client.post<ServiceResult>(
      FavoriteListingService.BASE,
      payload
    );
    return data;
  }

  /**
   * Get favorite listings for a user. Returns paginated list of FavoriteListingViewModel (each has .listing).
   */
  async getByUserId(userId: string): Promise<
    ServiceResultT<FavoriteListingViewModel[]>
  > {
    const { data } = await this.client.get<
      ServiceResultT<FavoriteListingViewModel[]>
    >(`${FavoriteListingService.BASE}/user/${userId}`);
    return data;
  }
}

export const favoriteListingService = new FavoriteListingService();
